import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface DmTinh {
  name: string;
  api_token: string;
}

export interface DmTinhListInfor {
  errors: unknown;
  dmTinh: DmTinh;
  isAuthenticated: boolean;
}

@Module
export default class DmTinhModule
  extends VuexModule
  implements DmTinhListInfor
{
  errors = {};
  dmTinh = {} as DmTinh;
  isAuthenticated = !!JwtService.getToken();

  get dmTinhs() {
    return this.dmTinhListData;
  }

  @Mutation
  [Mutations.DM_TINH_LIST_DATA](dmTinhs) {
    this.dmTinhListData = dmTinhs;
  }

  @Action
  [Actions.DM_TINH_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/province/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DM_TINH_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_TINH_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/province", payload)
        .then((data) => {
          this.context.commit(Mutations.DM_TINH_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_TINH_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "gis/province",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DM_TINH_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_TINH_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("gis/province", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.DM_TINH_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  get danhmucTinhDetail() {
    return this.dmTinhDetailData;
  }

  @Mutation
  [Mutations.DM_TINH_DETAIL_DATA](dmTinhDetail) {
    this.dmTinhDetailData = dmTinhDetail;
  }
  @Action
  [Actions.DM_TINH_DETAIL](payload) {
    return ApiService.getDataDetail("/gis/province", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.DM_TINH_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
